import * as React from 'react';

import cx from 'classnames';
import styles from './style.scss';

import Checkbox from '@stardust/checkbox';

import type { CheckboxProps } from '@stardust/checkbox';

export default function InputCheckbox({
  className,
  label,
  checked,
  onClick,
}: CheckboxProps) {
  return (
    <div
      className={cx(className, styles.checkboxWrapper, {
        [styles.checkboxWrapperChecked]: checked,
      })}
    >
      <Checkbox
        checked={checked}
        label={<label className={styles.checkboxLabel}>{label}</label>}
        onClick={onClick}
      />
    </div>
  );
}
